///
/// EarthBrowser
///
/// Created by Matt Giger on 1/11/2025
/// Copyright (c) 2025 Geodata Labs
///

import { DateField } from "@/components/dialogs/subscription/DateField"
import { capitalize } from "@/utils/utils"
import { PricingPlans } from "@shared-types/pricing-plans"
import { type Subscription } from "@shared-types/subscription"
import { Calendar, CalendarPlus2 } from "lucide-react"

export function SubscriptionCardCancelled({ subscription }: { subscription: Subscription }) {
	const pricingPlan = PricingPlans[subscription.subscription_id]
	if (!pricingPlan) {
		return null
	}
	const interval = pricingPlan.interval === "month" ? "Monthly" : "Yearly"

	return (
		<div className="rounded-lg border border-border bg-background p-3 opacity-60">
			<div className="flex items-center gap-3">
				<div className="p-2 rounded-lg bg-muted">
					{pricingPlan.interval == "year" ? (
						<CalendarPlus2 className="h-4 w-4 text-muted-foreground" />
					) : (
						<Calendar className="h-4 w-4 text-muted-foreground" />
					)}
				</div>
				<div className="flex flex-col gap-1 flex-1">
					<div className="flex items-center gap-2">
						<p className="text-sm font-semibold">{pricingPlan.name}</p>
						<span className="text-xs text-muted-foreground">·</span>
						<p className="text-xs text-muted-foreground">{interval}</p>
						<span className="px-2 py-0.5 rounded-full bg-muted text-muted-foreground text-xs font-medium">
							{capitalize(subscription.status)}
						</span>
					</div>
					<div className="flex items-center gap-3 text-xs text-muted-foreground">
						<div className="flex items-center">
							<span>Created</span>
							<DateField value={subscription.created_at} />
						</div>
						<span>·</span>
						<div className="flex items-center">
							<span>Cancelled</span>
							<DateField value={subscription.updated_at} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
